<template>
  <div class="md-layout ">
    <h1 class="md-title">Заявки на регистрацию</h1>
    <flt v-on:changeFilter="changeFilter"></flt>
    <tbl :key="keyTable" v-on:edit="edit"></tbl>
    <DialogCustomReq :key="keyDialog+'dialogCustom'" :openDialoi="openDialog" @closeDialogSuccess="closeDialog(true)"
                     @closeDialog="closeDialog()"></DialogCustomReq>
  </div>
</template>

<script>
import flt from './list/filter'
import tbl from './list/table'
import Vuex from 'vuex'
import store from '@/store'
import DialogCustomReq from './edit/index'

const registerFilter = new Vuex.Store({
  state: {
    filters: {
      country_code: store.getters.regionUser
    },
    search: '',
    pagination: {
      current_page: 0,
      count_page: 0
    },
    editID: null
  },
  mutations: {
    setFilter (obj, result) {
      if (result['value'] === 'deleteFilter') {
        this.state.filters[result['name']] = null
      } else {
        this.state.filters[result['name']] = result['value']
      }
    },
    resetPagination () {
      this.state.pagination = {
        current_page: 0,
        count_page: 0
      }
    }
  }
})

export default {

  data () {
    return {showTable: 1, filter: {}, keyTable: 1, keyDialog: 1, openDialog: 0}
  },
  name: 'indexRequests',
  components: {tbl, flt, DialogCustomReq},
  store: registerFilter,
  methods: {
    changeFilter () {
      this.$store.commit('resetPagination')
      this.keyTable++
    },
    edit () {
      this.keyDialog++
      this.openDialog = 1
    },
    closeDialog (flag) {
      this.openDialog = 0
      this.$store.state.editID = null
      if (flag === true) {
        this.keyTable++
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/registrationRequests/RegIndex.vue